import React, { useEffect, useState } from 'react'
import { Spin, Table, Button } from 'antd'
import { SAlert, STriggerModal } from 'shj-components'
import styles from './index.module.less'
import { useSetState } from 'ahooks'
import SubmitOfflineContract from '@/components/SubmitOfflineContract'
import { checkExpectProjectStartDate, checkQuoteElecConct } from '@/services/order.ts'

const ContractDialog = ({ open = false, closeDialog = () => ({}), contractMap = {} }: any) => {
  const [spinLoading, setSpinLoading] = useState(false)
  const [state, setState] = useSetState<any>({
    visible: false,
    data: {},
    signVisible: false,
    signReadOnly: false,
    submitLoading: false,
    elecContractId: '',
    signData: [],
    signDataNew: {},
    tableList: [],
  })
  const [currentContractList, setCurrentConractList] = useState(false)
  const [checkStartDate, setCheckStartDate] = useState<boolean | null>(null) //检查是否能发起合同
  const [quoteId, setQuoteId] = useState('')
  const [orderId, setOrderId] = useState('')
  const [errorList, setErrorList] = useState([]);

  const columns: any[] = [
    {
      title: '合同名称',
      dataIndex: 'contractTitle',
      width: 'auto',
    },
    {
      title: '合同类型',
      dataIndex: 'onlineFlag',
      width: 'auto',
      render: (val: boolean) => <div>{val ? '线上合同' : '线下合同'}</div>,
    },
  ]

  useEffect(() => {
    if (!open) return;
    initData();
  }, [open, contractMap])

  const initData = async () => {

    const keys = Object.keys(contractMap?.budgetPrintInfoMap || {})
    if (keys.length === 0) {
      return
    }
    if(!contractMap?.budgetPrintInfoMap[keys[0]]?.orderId || !contractMap?.budgetPrintInfoMap[keys[0]]?.budgetId){
      return;
    }
    setSpinLoading(true)
    const res = await checkQuoteElecConct({
      quoteBudgetId: [keys[0]]
    })
    if (Array.isArray(res) && res?.length) {
      setErrorList(res);
    }
    checkExpectProjectStartDate({
      orderId: contractMap?.budgetPrintInfoMap[keys[0]]?.orderId,
      budgetId: contractMap?.budgetPrintInfoMap[keys[0]]?.budgetId,
    })
      .then(res => setCheckStartDate(Boolean(res)))
      .catch(error => {
        console.error('检查预计开工时间失败:', error)
        setCheckStartDate(false)
      })
      .finally(() => setSpinLoading(false))
  }

  const handleOpenContractModal = (list: any, id: string) => {
    setCurrentConractList(list || [])
    setQuoteId(id)
    setOrderId(contractMap?.budgetPrintInfoMap?.[id]?.orderId)
    setState({
      signVisible: true,
    })
  }

  const handleGoContractSystem = (item: string) => {
    window.open('/print/printSkuMenu.html?bizopBudgetHeaderId=' + item)
  }

  const onlyMainContent = () => {
    return (
      <div className={styles.onlyMainContent}>
        {errorList?.length ? <div className={styles.errorBox}>
          <SAlert type="error">
            {errorList?.length > 0 && <p style={{color: 'red'}}>异常信息：</p>}
            {errorList?.map((item: any, index: number) => {
              return (
                <p style={{color: 'red'}}>
                  <span>
                    {index + 1}、{item}
                  </span>
                </p>
              )
            })}
          </SAlert>
        </div> : null }
        {checkStartDate === false && (
          <div className={styles.errorBox}>
            <SAlert type="error">
              还未选择开工日期，无法发起合同；请与客户确认预期时间，并选择开工日期后再发起
            </SAlert>
          </div>
        )}
        {contractMap?.discountFlag && (
          <div style={{ marginBottom: 10 }}>
            <SAlert type="warning">{contractMap?.discountInfo}</SAlert>
          </div>
        )}
        {Object?.keys(contractMap?.budgetPrintInfoMap || {} ) &&
        Object?.keys(contractMap?.budgetPrintInfoMap || {} )?.length
          ? Object?.keys(contractMap?.budgetPrintInfoMap || {} )?.map((item: any, index) => (
              <div className={styles.contractBox} key={'contractTable' + index}>
                <div className={styles.contractTableTitle}>
                  <div className={styles.title}>
                    {contractMap?.budgetPrintInfoMap?.[item]?.goodsName}
                  </div>
                  <div className={styles.buttons}>
                    {contractMap?.budgetPrintInfoMap?.[item]?.list?.filter(
                      (item: any) => item.onlineFlag
                    )?.length ? (
                      <Button
                        type={'primary'}
                        className={styles.button}
                        disabled={!checkStartDate || contractMap?.discountFlag || errorList?.length}
                        onClick={() => handleGoContractSystem(item)}
                      >
                        去发起线上合同
                      </Button>
                    ) : null}
                    {contractMap?.budgetPrintInfoMap?.[item]?.list?.filter(
                      (item: any) => !item.onlineFlag
                    )?.length ? (
                      <Button
                        type={'primary'}
                        className={styles.button}
                        disabled={!checkStartDate || contractMap?.discountFlag || errorList?.length}
                        onClick={() =>
                          handleOpenContractModal(
                            contractMap?.budgetPrintInfoMap?.[item]?.list?.filter(
                              (item: any) => !item.onlineFlag
                            ),
                            item
                          )
                        }
                      >
                        去发起线下合同
                      </Button>
                    ) : null}
                  </div>
                </div>
                <Table
                  dataSource={contractMap?.budgetPrintInfoMap?.[item]?.list || []}
                  columns={columns}
                  pagination={false}
                />
              </div>
            ))
          : null}
      </div>
    )
  }

  const dialogContent = () => {
    return (
      <Spin spinning={spinLoading}>
        <div className={styles.TianMasterDialog}>{onlyMainContent()}</div>
      </Spin>
    )
  }

  return (
    <div className={styles.ContractDialog}>
      {state.signVisible && (
        <SubmitOfflineContract
          state={state}
          setState={setState}
          open={state.signVisible}
          currentContractList={currentContractList}
          quoteId={quoteId}
          orderId={orderId}
        />
      )}
      <STriggerModal
        zIndex={1999}
        open={open}
        onClose={closeDialog}
        title="合同列表"
        okText="保存"
        cancelText="取消"
        centered={true}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        onCancel={() => {
          closeDialog()
        }}
      >
        {dialogContent()}
      </STriggerModal>
    </div>
  )
}

export default ContractDialog
